import modelBaseV2 from "../model-base-v2.model";

let PerformanceModel = {
    getSalesPerformances: (filter) => {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get('/api/performance/sales?' + qs);
    },
    getSalesPerformancesDetail: (filter) => {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get('/api/performance/sales/detail?' + qs);
    },
    getSalesPerformancesSelloutbyMarketingName: (filter) => {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get('/api/performance/selloutbymarketingname?' + qs);
    },
    getScheduleVisitPlan: (filter) => {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get('/api/schedule/visitplan?' + qs);
    },
    getToDoComplusoryTask: (filter) => {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get('/api/todo/complusorytask?' + qs);
    },
    getScheduleStoreVisitTask: (filter) => {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get('/api/schedule/storevisitandtask?' + qs);
    },
    downloadTargetAchievementsExcel: (request, fileName) => {
        let params = {};
        params.sortBy = "",
            params.orderBy = "",
            params.pageIndex = 0,
            params.pageSize = 0,
            params.storedProcedureCode = "12",
            params.params = [
                { code: "34", value: request.fromMonth },
                { code: "35", value: request.toMonth },
                { code: "36", value: request.siteGroup }, //site Group
                { code: "25", value: request.site }, //site ID
                { code: "37", value: "" }, { code: "38", value: "" }];
        params.excelSheetNames = ["Sales - Target vs Achievements"];
        return modelBaseV2.postDownload('/api/executesp/export/tr/file', { body: params }, fileName + ".xlsx");
    },

    downloadVisitStoreExcel: (request, fileName) => {
        let params = {};
        params.sortBy = "",
            params.orderBy = "",
            params.pageIndex = 0,
            params.pageSize = 0,
            params.storedProcedureCode = "13",
            params.params = [
                { code: "40", value: request.PeriodType },
                { code: "41", value: request.fromPeriod },
                { code: "42", value: request.toPeriod },
                { code: "36", value: request.SiteGroupID }, //site Group
                { code: "25", value: request.SiteId }];
        params.excelSheetNames = ["Visit Store and Task"];
        return modelBaseV2.postDownload('/api/executesp/export/tr/file', { body: params }, fileName + ".xlsx");
    },

    downloadMonthlySelloutExcel: (request, fileName) => {
        let params = {};
        params.sortBy = "",
            params.orderBy = "",
            params.pageIndex = 0,
            params.pageSize = 0,
            params.storedProcedureCode = "14",
            params.params = [
                { code: "43", value: request.selectMonth },
                { code: "2", value: request.sortBy + " " + request.OrderBy }];
        params.excelSheetNames = ["Monthly Sellout by Marketing Name"];
        return modelBaseV2.postDownload('/api/executesp/export/tr/file', { body: params }, fileName + ".xlsx");
    },
}

export default PerformanceModel;
